export default __webpack_public_path__ + "static/kv_common-9409f77606fa02936ede31a91b52f919.jpg";